function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
  - renderSuggestion
  - fetchSuggestion
  - selectSuggestion
  - normalizeSuggestion (optional)
  - normalizeInput (optional)
  - suggestions
  - total (optional)
  - name
  - error
  - required (optional)
  - disabled (optional)
  - label (optional)
  - placeholder (optional)
  - footer: { component, value } (optional)
  - turnOnClickOutListener: (optional, defaults to true)
*/
import { useRef, useState } from 'react';
import Label from './Label';
import { apricot } from '../../profile';
import { numberFormat } from '../../numeral';
import styles from '../../../sass/forms.module.scss';
export default (function (props) {
  var fetchSuggestions = props.fetchSuggestions,
      renderSuggestion = props.renderSuggestion,
      selectSuggestion = props.selectSuggestion,
      normalizeSuggestion = props.normalizeSuggestion,
      normalizeInput = props.normalizeInput,
      footer = props.footer,
      error = props.error,
      label = props.label,
      arialabel = props.arialabel,
      _props$formGroupStyle = props.formGroupStyles,
      formGroupStyles = _props$formGroupStyle === void 0 ? {} : _props$formGroupStyle,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      name = props.name,
      _onBlur = props.onBlur,
      _onChange = props.onChange,
      placeholder = props.placeholder,
      required = props.required,
      value = props.value,
      disabled = props.disabled,
      _props$turnOnClickOut = props.turnOnClickOutListener,
      turnOnClickOutListener = _props$turnOnClickOut === void 0 ? true : _props$turnOnClickOut,
      _props$minCharacterSe = props.minCharacterSearchLength,
      minCharacterSearchLength = _props$minCharacterSe === void 0 ? 2 : _props$minCharacterSe,
      _props$suggestionIdPr = props.suggestionIdPrefix,
      suggestionIdPrefix = _props$suggestionIdPr === void 0 ? 'autosuggest-option' : _props$suggestionIdPr;

  var _ref = footer || {},
      _ref$alwaysVisible = _ref.alwaysVisible,
      footerAlwaysVisible = _ref$alwaysVisible === void 0 ? false : _ref$alwaysVisible;

  var _apricot$utils$keys = apricot().utils.keys,
      DOWN = _apricot$utils$keys.DOWN,
      UP = _apricot$utils$keys.UP,
      ENTER = _apricot$utils$keys.ENTER,
      TAB = _apricot$utils$keys.TAB,
      ESC = _apricot$utils$keys.ESC;

  var _useState = useState(footerAlwaysVisible),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      changeOpenStatus = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      suggestions = _useState4[0],
      setSuggestions = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      total = _useState6[0],
      setTotal = _useState6[1];

  var containerRef = useRef(null);
  var inputRef = useRef(null);
  var accessibleId = "autosuggest-".concat(name);
  var accessibleDirectionsId = "".concat(accessibleId, "-directions");
  var errId = error ? "errMessage-".concat(name) : null;
  var footerId = footer ? "".concat(suggestionIdPrefix, "-").concat(suggestions.length) : '';

  function reset() {
    setOpen(false);
    setSuggestions([]);
    setTotal(0);
  }

  function select(s) {
    selectSuggestion(normalizeSuggestion ? normalizeSuggestion(s) : s);
    reset();
    inputRef.current.focus();
  }

  function setOpen(newOpenValue) {
    changeOpenStatus(newOpenValue || footerAlwaysVisible);
  }

  function fetch(_x) {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
      var _yield$fetchSuggestio, suggestions, total;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchSuggestions(value);

            case 2:
              _yield$fetchSuggestio = _context.sent;
              suggestions = _yield$fetchSuggestio.suggestions;
              total = _yield$fetchSuggestio.total;
              setOpen(Boolean(total));
              setSuggestions(suggestions);
              setTotal(total);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetch.apply(this, arguments);
  }

  function closeAutosuggestionOnClickOut(e) {
    var _ref2 = containerRef || {},
        elem = _ref2.current;

    var focusedOnMenu = elem && elem.contains(e.target);
    if (!focusedOnMenu && isOpen) reset();
  }

  function blurEvent(e) {
    if (e.keyCode === TAB || e.keyCode === ESC) reset();
    if (e.keyCode === ESC) inputRef.current.focus();
  }

  function suggestionKeyDown(e, s) {
    var index = parseInt(e.target.dataset.index, 10);
    e.preventDefault(e);
    blurEvent(e);

    if (e.keyCode === ENTER && s) {
      e.preventDefault();
      select(s, e);
    } else if (e.keyCode === DOWN && (footer && index < suggestions.length || index < suggestions.length - 1)) {
      document.getElementById("".concat(suggestionIdPrefix, "-").concat(index + 1)).focus();
    } else if (e.keyCode === UP && index > 0) {
      var elem = document.getElementById("".concat(suggestionIdPrefix, "-").concat(index - 1));
      if (elem) elem.focus();else inputRef.current.focus();
    } else if (e.keyCode === DOWN && (footer && index === suggestions.length || index === suggestions.length - 1) || e.keyCode === UP && index === 0) {
      inputRef.current.focus();
    }
  }

  useEffect(function () {
    if (turnOnClickOutListener) {
      document.addEventListener('click', closeAutosuggestionOnClickOut);
      return function () {
        return document.removeEventListener('click', closeAutosuggestionOnClickOut);
      };
    }
  }, []); // Suggestions added in index 0-9
  // Footer, if provided, added at index suggestion.length

  function renderSuggestions() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['autosuggest-list'],
      style: {
        display: "".concat(isOpen ? 'block' : 'none')
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only",
      id: accessibleDirectionsId
    }, "Use up and down arrows to select"), total ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles['autosuggest-item'], " ").concat(styles['autosuggest-total'])
    }, "Found ", numberFormat(total), " results. Keep typing to narrow the results.") : null, /*#__PURE__*/React.createElement("ul", {
      role: "listbox",
      id: accessibleId
    }, suggestions.map(function (s, i) {
      var id = "".concat(suggestionIdPrefix, "-").concat(i);
      return /*#__PURE__*/React.createElement("li", {
        role: "presentation",
        key: id
      }, /*#__PURE__*/React.createElement("button", {
        role: "option",
        type: "button",
        className: styles['autosuggest-item'],
        id: id,
        "data-index": i,
        onClick: function onClick() {
          return select(s);
        },
        onKeyDown: function onKeyDown(e) {
          return suggestionKeyDown(e, s);
        }
      }, renderSuggestion(s)));
    }), footer ? /*#__PURE__*/React.createElement("li", {
      role: "presentation",
      key: footerId
    }, /*#__PURE__*/React.createElement(footer.component, {
      role: "option",
      className: "".concat(styles['autosuggest-item'], " ").concat(styles['autosuggest-footer']),
      id: footerId,
      "data-index": suggestions.length,
      onKeyDown: function onKeyDown(e) {
        return suggestionKeyDown(e, footer.value);
      },
      onClick: function onClick() {
        return footer.value ? select(footer.value) : null;
      }
    })) : null));
  }

  function renderInput() {
    var val = value || '';
    return /*#__PURE__*/React.createElement("div", {
      className: "cb-input-state ".concat(styles['input-wrapper']),
      role: "combobox",
      haspopup: "listbox",
      "aria-owns": accessibleId,
      "aria-expanded": isOpen,
      "aria-labelledby": name
    }, /*#__PURE__*/React.createElement("input", {
      name: name,
      id: name,
      value: normalizeInput ? normalizeInput(val) : val,
      placeholder: placeholder,
      required: required,
      disabled: disabled,
      ref: inputRef,
      onChange: function onChange(e) {
        if (e.target.value.length > minCharacterSearchLength) fetch(e.target.value);else reset();
        if (_onChange) _onChange(e);
      },
      onBlur: function onBlur(e) {
        e.preventDefault();
        if (_onBlur) _onBlur(e);
      },
      onFocus: function onFocus(e) {
        return e.target.select();
      },
      onKeyDown: function onKeyDown(e) {
        blurEvent(e);

        if (e.keyCode === DOWN && isOpen) {
          var id = suggestions.length ? "".concat(suggestionIdPrefix, "-0") : footer ? footerId : null;
          e.preventDefault();
          if (id) document.getElementById(id).focus();
        } // User should not be able to simply enter text and hit enter to submit.
        // The user must select an item from the returned suggestions and
        // proceed through the form from there.


        if (e.keyCode === ENTER) {
          e.preventDefault();
        }
      },
      autoComplete: "off",
      "aria-label": arialabel || label || placeholder,
      "aria-describedby": error ? errId : accessibleDirectionsId,
      "aria-controls": accessibleId,
      "aria-autocomplete": "list",
      "aria-required": required,
      className: "form-control"
    }), /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-search",
      "aria-hidden": true
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(styles['autosuggest-wrapper'], " ").concat(error && !isOpen ? 'has-error' : '', "  ").concat(disabled ? 'disabled' : '', " ").concat(className),
    style: formGroupStyles,
    ref: containerRef
  }, label ? /*#__PURE__*/React.createElement(Label, {
    id: name,
    required: required,
    label: label
  }) : null, renderInput(), renderSuggestions(), error && !isOpen ? /*#__PURE__*/React.createElement("p", {
    tabIndex: "-1",
    id: errId,
    className: "cb-error-msg",
    role: "alert"
  }, error) : null);
});